import { Inject, Injectable } from "@angular/core";
import { DispositionsModuleData } from "./dispositions.model";
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

// Don't forget to add the service to dashboard.main.ts:
//     service(...provide(TsTemplateService))
@Injectable({
    providedIn: 'root'
})
export class DispositionsService {
    public dataObj: DispositionsModuleData = null;

    constructor(
        private cvApiService: CVApiService,
    ) { }

    /** Get data for dispositions module from endpoint */
    public async loadDispositionsData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            let url = `/api/v2/dashboards/modules/dispositions/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            let response = await this.cvApiService.get(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed loading data for dispositions module");
            throw err;
        }
    };

    /** Get data formatted for export for dispositions module from endpoint */
    public async getDispositionsDataForExport(moduleKey: string, format: string, sort: string) {
        try {
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            let url = `/api/v2/dashboards/modules/dispositions/${moduleKey}/export?format=${format}&sort=${sort}`;
            let response = await this.cvApiService.get(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting data for exporting dispositions module");
            throw err;
        }
    }
}
